import { api } from "aldoo-ra/API"

// Admin transfer browser endpoint (/v1/admin-transfers). Credentials are injected
// automatically by api(); the server gates every action on role:admin.
const adminAPI = api("admin-transfers")

// DataTable hands `search` as a Mongo-style object ({ q: term } or { $or:[…] }).
// The server runs its own field matching, so flatten it back to the raw term.
const searchTerm = (search) => {
  if (!search) return undefined
  if (typeof search === "string") return search
  const first = Array.isArray(search.$or) ? search.$or[0] : search
  const val = first && Object.values(first)[0]
  return typeof val === "string" ? val : undefined
}

// DataTable apiMethod protocol: receives { page, itemsPerPage, search, sort } and
// returns { data, total }.
export const ListTransfers = (opts = {}) =>
  adminAPI({
    transfers: {
      page: opts.page || 1,
      itemsPerPage: opts.itemsPerPage || 25,
      search: searchTerm(opts.search),
      sort: opts.sort,
    },
  })

export const ListReceiveLinks = (opts = {}) =>
  adminAPI({
    receiveLinks: {
      page: opts.page || 1,
      itemsPerPage: opts.itemsPerPage || 25,
      search: searchTerm(opts.search),
      sort: opts.sort,
    },
  })

// Per-user transfer quota usage. Server returns rolling-30d usedBytes/count
// + lifetime totals + plan info (name, monthly allowance).
export const ListQuotas = (opts = {}) =>
  adminAPI({
    quotas: {
      page: opts.page || 1,
      itemsPerPage: opts.itemsPerPage || 25,
      search: searchTerm(opts.search),
      sort: opts.sort,
    },
  })

// Files of a single order — read from order.meta.files (DB-only, no R2).
export const ListOrderFiles = (orderID) => adminAPI({ files: { orderID } })

// Presigned download URL for one file — the only call that touches R2.
export const GetFileUrl = (orderID, name) => adminAPI({ fileUrl: { orderID, name } })

// Aggregate stats across all file-share orders.
export const GetStats = () => adminAPI({ stats: {} })
